import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Globe, MapPin, TrendingUp, ArrowRight } from 'lucide-react';
import { countries } from '../data/mockData';
import './Destinations.css';

function Destinations() {
  const [selectedContinent, setSelectedContinent] = useState('Alle');

  const continents = ['Alle', 'Europa', 'Asien', 'Amerika', 'Afrika'];
  
  const filteredCountries = selectedContinent === 'Alle' 
    ? countries 
    : countries.filter(c => c.continent === selectedContinent);

  return (
    <section id="destinations" className="section destinations">
      <div className="destinations-header">
        <div>
          <h2 className="section-title">Unsere Reiseziele</h2>
          <p className="section-subtitle">Entdecke über 20 handverlesene Destinationen mit echten Insider-Tipps</p>
        </div>
        <div className="continent-filter">
          {continents.map(continent => (
            <button
              key={continent}
              className={`filter-btn ${selectedContinent === continent ? 'active' : ''}`}
              onClick={() => setSelectedContinent(continent)}
            >
              {continent}
            </button>
          ))}
        </div>
      </div>

      <div className="destinations-grid">
        {filteredCountries.map(country => (
          <Link 
            to={`/destination/${country.id}`} 
            key={country.id} 
            className="destination-card card card-hover"
          >
            <div className="destination-image-wrapper">
              <img src={country.image} alt={country.name} className="destination-image" />
              <div className="destination-continent-badge">{country.continent}</div>
            </div>
            
            <div className="destination-content">
              <h3 className="destination-name">
                <MapPin size={20} />
                {country.name}
              </h3>
              
              <div className="destination-stats">
                <div className="stat-box">
                  <TrendingUp size={16} />
                  <span>Nomad Score: {country.valueScore.nomadScore}</span>
                </div>
                <div className="stat-box">
                  <Globe size={16} />
                  <span>{country.optimalAirports.length} Flughäfen</span>
                </div>
              </div>

              <div className="destination-highlights">
                <div className="highlight-item">
                  <span className="highlight-label">Beste Reisezeit:</span>
                  <span className="highlight-value">{country.optimalTravelTime.best}</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Ø Lebenskosten:</span>
                  <span className="highlight-value">{country.valueScore.livingCosts}</span>
                </div>
              </div>

              <div className="destination-cta">
                <span>Details anzeigen</span>
                <ArrowRight size={18} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default Destinations;
